import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { EffectCoverflow } from '../lib/swiper/effectCoverflow';

export function initApplication() {
  const parent = document.querySelector('.application');
  if (!parent) return;

  const sections = parent.querySelectorAll('.application__section');

  const counterEl = parent.querySelector('.swiper-counter');

  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  const swiper = new Swiper('.application__swiper .swiper', {
    modules: [Pagination, EffectCoverflow, Navigation, Autoplay],
    autoplay: {
      disableOnInteraction: true,
    },
    speed: 1000,
    loop: true,
    effect: 'coverflow',
    grabCursor: true,
    slidesPerView: 'auto',
    coverflowEffect: {
      rotate: 0,
      stretch: 100,
      depth: 300,
      modifier: 1,
      scale: 1,
      slideShadows: false,
    },
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  swiper.on('slideChange', () => {
    const idx = swiper.realIndex;
    counterEl.innerHTML = (idx + 1).toString().padStart(2, '0');

    sections.forEach((s, sIdx) => {
      s.hidden = sIdx === idx ? false : true;
    });
  });

  // lazy load videos
  ScrollTrigger.create({
    trigger: '.landing-hero',
    start: 'bottom top',
    once: true,
    onEnter: () => {
      const videos = parent.querySelectorAll('.application__video');
      videos.forEach((v) => {
        const hevc = new URL(v.dataset.hevcSrc, import.meta.url).href;
        const webm = new URL(v.dataset.webmSrc, import.meta.url).href;

        const sources = `
          <source
            src="${hevc}"
            type="video/mp4; codecs=hvc1"
          />
          <source
            src="${webm}"
            type='video/webm; codecs="vp9"'
          />
        `;
        v.innerHTML = sources;
        try {
          v.play();
        } catch (e) {}
      });
    },
  });
}
